import { Box, FlexBox } from '@dixa/lib-shared-habla';
import type { ConversationTextualMediaMessageAddedEvent } from 'lib-shared-types-api';
import { useCallback } from 'react';

import { ConversationMessageAttachments } from './components/messageAttachments/conversationMessageAttachments';
import styles from './conversationTextualMediaMessageEvents.module.scss';
import { ConversationTextualMessageEventsProps } from './conversationTextualMediaMessageEvents.types';

/**
 * Represents the component for rendering textual media conversation message
 * events.
 */
export const ConversationTextualMediaMessageEvents = <
  TConversationTextualMediaMessageAddedEvent extends ConversationTextualMediaMessageAddedEvent,
>({
  events,
  hideAttachments,
  renderEventText,
}: ConversationTextualMessageEventsProps<TConversationTextualMediaMessageAddedEvent>): JSX.Element => {
  const getEventText = useCallback(
    (event: TConversationTextualMediaMessageAddedEvent) => {
      return (
        <Box dir="auto">
          {renderEventText ? renderEventText(event) : event.text}
        </Box>
      );
    },
    [renderEventText],
  );

  const getEventAttachments = useCallback(
    (event: TConversationTextualMediaMessageAddedEvent) => {
      return (
        'attached_files' in event &&
        event.attached_files &&
        !hideAttachments && (
          <ConversationMessageAttachments attachments={event.attached_files} />
        )
      );
    },
    [hideAttachments],
  );

  return (
    <FlexBox flexDirection="column" gap="300" className={styles.event}>
      {events.map((event) => (
        <FlexBox key={event.id} flexDirection="column" gap="100">
          {getEventText(event)}
          {getEventAttachments(event)}
        </FlexBox>
      ))}
    </FlexBox>
  );
};
